// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
// import vueFilter from "src/assets/js/filter";
import QRCode from 'qrcodejs2'
// import "amfe-flexible";
import wxlogin from 'vue-wxlogin'
window.QRCode = QRCode
import * as Lockr from 'lockr'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import 'videojs-contrib-hls'
import 'videojs-hotkeys'
// import JInput from 'src/components/j-input.vue'
import JVideo from 'src/components/j-video.vue'
// cssVars({ watch: true })
Vue.prototype.lockr = Lockr
Vue.component('videoPlayer', videoPlayer)
Vue.component('wxlogin', wxlogin)
// for (let key in vueFilter) {
//   Vue.filter(key, vueFilter[key]);
// }
// console.log(JInput)

// Vue.component('ElInput', JInput)
Vue.component('JVideo', JVideo)

const bus = new Vue()
Vue.prototype.$bus = bus


import moment from 'moment';
Vue.prototype.$moment = moment